<template>
  <div class="o-main-grid">
    <div class="o-main-grid__col is-col1">
        <slot name="layout-left"></slot>
    </div>

    <div class="o-main-grid__col is-col2">
        <slot name="layout-right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LandingLayout',
}
</script>
